<template>
  <v-container class="my-auto">
    <v-row>
      <v-card class="mx-auto" max-width="400">
        <v-img
          class="white--text align-end"
          height="200px"
          src="../assets/i/login-bg.jpg"
        >
        <v-card-title>Pincode Mapper</v-card-title>
        </v-img>
        <v-card-text>
          <v-alert
            transition="scroll-y-transition"
            prominent
            type="error"
            :value="error.status"
          >{{error.message}}</v-alert>
          <v-alert
            transition="scroll-y-transition"
            prominent
            type="success"
            :value="success.status"
          >{{success.message}}</v-alert>
          <v-form
            class="text-center"
            ref="loginForm"
            @submit.prevent="login"
          >
            <v-text-field
              label="Login Email"
              color="accent"
              :rules="usernameRules"
              prepend-inner-icon="mdi-account"
              v-model="auth.email"
              required
            ></v-text-field>
            <v-text-field
              label="Password"
              color="accent"
              type="password"
              :rules="passwordRules"
              prepend-inner-icon="mdi-account-key"
              v-model="auth.password"
              required
            ></v-text-field>
            <v-btn
              type="submit"
              color="accent"
              :loading="proccessing"
            >Sign In</v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      auth: {
        email: '',
        password: '',
      },
      usernameRules: [
        (v) => !!v || 'Email is required',
        (v) => (v && v.length > 3) || 'Email must be minimum 3 characters',
      ],
      passwordRules: [
        (v) => !!v || 'Password is required',
        (v) => (v && v.length > 5) || 'Password must be minimum 5 characters',
      ],
      success: {
        status: false,
        message: '',
      },
      error: {
        status: false,
        message: '',
      },
      proccessing: false,
    };
  },
  methods: {
    async login() {
      this.error.status = false;
      this.success.false = false;
      if (this.$refs.loginForm.validate()) {
        this.proccessing = true;
        try {
          await this.firebase.auth().signInWithEmailAndPassword(
            this.auth.email,
            this.auth.password,
          );
          this.proccessing = false;
          // console.log(user);
        } catch (error) {
          this.proccessing = false;
          console.log(error);
          this.error.status = true;
          this.error.message = 'Unknown Error! Please try again';
          if (error.code === 'auth/user-not-found') {
            this.error.message = 'User Not Found';
          }
        }
      }
    },
  },
};
</script>
